import { Card } from '@/components/atoms/Card';
import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';

import styles from './HealthDashboardSkeleton.module.scss';

const SKELETON_ALERT_CARD_COUNT = 2;

const SKELETON_PARAMETER_ROW_COUNT = 8;

export default function HealthDashboardSkeleton() {
    return (
        <>
            <div className={styles.mainColumn} aria-busy="true">
                <Card as="section" padding="lg" fullWidth>
                    <div className={styles.alertsList}>
                        {Array.from({ length: SKELETON_ALERT_CARD_COUNT }, (_, index) => (
                            <div key={index} className={styles.alertCardSkeleton}>
                                <SkeletonBox width="40%" height={20} borderRadius={4} />
                                <SkeletonBox width="100%" height={48} borderRadius={8} />
                            </div>
                        ))}
                    </div>
                </Card>

                <Card as="section" padding="lg" fullWidth>
                    <div className={styles.summaryList}>
                        {Array.from({ length: SKELETON_PARAMETER_ROW_COUNT }, (_, index) => (
                            <SkeletonBox key={index} width="100%" height={44} borderRadius={8} />
                        ))}
                    </div>
                </Card>
            </div>

            <div className={styles.infoPanel}>
                <Card padding="lg">
                    <div className={styles.infoPanelInner}>
                        <SkeletonBox width="50%" height={20} borderRadius={4} />
                        <SkeletonBox width="70%" height={16} borderRadius={4} />
                        <SkeletonBox width="100%" height={72} borderRadius={8} />
                    </div>
                </Card>
            </div>
        </>
    );
}
